<template>
  <card-seplag titulo="Chefia por Unidade">
    <div class="p-col-12">
      <div class="p-grid alinhamentoBuscaOrgaoVinculado">
        <Rotulo nome="Selecione um Órgão:" cols="12 3">
          <Dropdown
            v-model="orgaoSelecionado"
            :options="orgaoBusca"
            optionLabel="labelDropDaw"
            placeholder="Selecione..."
            :filter="true"
            @change="buscaUnidadesVinculado()"
          />
        </Rotulo>
        <Rotulo nome="Setor:" cols="12 3">
          <Dropdown
            v-model="unidadeSelecionadoFiltro"
            :options="listaUnidadesFiltro"
            optionLabel="labelDropDaw"
            placeholder="Selecione..."
            filter
            showClear
            :disabled="orgaoSelecionado && listaUnidadesFiltro.length == 0"
          />
        </Rotulo>
        <div class="p-col-12 p-md-3">
          <Button
            label="Buscar"
            class="p-button-info"
            icon="pi pi-search"
            @click="buscaUnidadeFiltro()"
          />
        </div>
      </div>
    </div>
    <div
      class="p-col-12 unidadesVinculados"
      v-if="unidadesDisponiveis.length > 0"
    >
      <table-seplag
        :dados="unidadesDisponiveis"
        :exibirCabecalho="false"
        :campos="[]"
        :paginacao="true"
        :totalRegistro="totalRecords"
        :onSearchPaginacao="buscaUnidadeFiltro"
      >
        <Column
          field="descUnidadePai"
          header="Superitendência"
          :headerStyle="{ width: '25em' }"
          :bodyStyle="{ wordBreak: 'break-word' }"
        >
          <template #body="slotProps">
            <p>{{ slotProps.data.descUnidadePai }}</p>
          </template>
        </Column>

        <Column
          field="codgSeap"
          header="Cód. Setor"
          :headerStyle="{ width: '10em' }"
          :bodyStyle="{ wordBreak: 'break-word' }"
        >
          <template #body="slotProps">
            <p>{{ slotProps.data.codgSeap }}</p>
          </template>
        </Column>

        <Column
          field="descUnidade"
          header="Setor"
          :headerStyle="{ width: '40em' }"
          :bodyStyle="{ wordBreak: 'break-word' }"
        >
          <template #body="slotProps">
            <p>{{ slotProps.data.descUnidade }}</p>
          </template>
        </Column>

        <Column
          field="chefes"
          header="Chefia/Matrícula"
          :headerStyle="{ width: '20em' }"
          :bodyStyle="{ wordBreak: 'break-word' }"
        >
          <template #body="slotProps">
            <p>
              {{
                slotProps.data.chefes.length > 0
                  ? slotProps.data.chefes.map(function (element) {
                      return element.nome + "/" + element.numrMatricula;
                    })[0]
                  : "-"
              }}
            </p>
          </template>
        </Column>

        <Column field="flagPermissaoAlterar" header="Situação">
          <template #body="slotProps">
            <Message
              :severity="
                slotProps.data.chefes.length > 0
                  ? slotProps.data.flagPermissaoAlterar == 'N'
                    ? 'success'
                    : 'warn'
                  : 'error'
              "
              :closable="false"
              >{{
                slotProps.data.chefes.length > 0
                  ? slotProps.data.flagPermissaoAlterar == "N"
                    ? "Atribuido Pelo SEAP"
                    : "Atribuição Pelo RH"
                  : "Não Informado"
              }}</Message
            >
          </template>
        </Column>

        <Column
          headerStyle="width: 6em"
          bodyStyle="text-align: center;"
          header="Servidores"
        >
          <template #body="slotProps">
            <Button
              type="button"
              icon="pi pi-users"
              v-tooltip.top="'Lista Servidores'"
              @click="abrirModalServidores(slotProps.data)"
            ></Button>
          </template>
        </Column>
      </table-seplag>
    </div>
    <cadastro-rapido
      v-model="exibirServidores"
      tituloTela="Lista Servidores"
      tamanhoTela="70.em"
      :visivelFechar="false"
      modoEdicao="alterar"
      textoButton="Fechar"
      :onAlterar="fecharModalServidores"
      v-if="unidadeSelecionada"
    >
      <div class="p-grid">
        <div class="p-col-12">
          <div class="p-grid alinhamentoBuscaOrgaoVinculado">
            <Rotulo nome="Nome/Matricula:" cols="12 3">
              <InputText
                type="text"
                v-model="parametroPesquisaListaServidor"
                v-on:keyup.enter="paginacaoListaServidores()"
              />
            </Rotulo>
            <div class="p-col-12 p-md-3">
              <Button
                label="Buscar"
                class="p-button-info"
                icon="pi pi-search"
                @click="paginacaoListaServidores()"
              />
            </div>
          </div>
        </div>
        <div class="p-col-12" v-if="unidadesDisponiveis.length > 0">
          <table-seplag
            :dados="listaServidorUnidade"
            :exibirCabecalho="false"
            :campos="[]"
            :paginacao="true"
            :onSearchPaginacao="paginacaoListaServidores"
            :totalRegistro="totalRecordsServidorUnidade"
          >
            <Column field="idenPessoa" header="ID">
              <template #body="slotProps">
                <!-- <p v-if="controle">{{ slotProps.data.pessoa.idenPessoa }}</p> -->
                <p>{{ slotProps.data.idenPessoa }}</p>
              </template>
            </Column>
            <Column field="numrMatricula" header="Matrícula">
              <template #body="slotProps">
                <!-- <p >{{ slotProps.data.pessoa.numMatricula }}</p> -->
                <p>{{ slotProps.data.numrMatricula }}</p>
              </template>
            </Column>
            <Column
              field="nome"
              header="Nome Servidor"
              :headerStyle="{ width: '50em' }"
              :bodyStyle="{ wordBreak: 'break-word' }"
            >
              <template #body="slotProps">
                <!-- <p>{{ slotProps.data.pessoa.nomePessoa }}</p> -->
                <p>{{ slotProps.data.nome }}</p>
              </template>
            </Column>
            <Column
              field="idenPessoa"
              header="Atribuir Chefia"
              :headerStyle="{ width: '10em' }"
              :bodyStyle="{ textAlign: 'center' }"
            >
              <template #body="slotProps">
                <InputSwitch
                  v-model="slotProps.data.checked"
                  @change="atribuirChefiaUnidade(slotProps.data)"
                  :disabled="
                    isPerfil != 'SISTEMA' &&
                    isPerfil != 'CENTRAL' &&
                    isUnidadeChefia
                  "
                  v-if="slotProps.data.chefeSEAP == false"
                />
                <p v-else><strong>CHEFIA SEAP</strong></p>
              </template>
            </Column>
          </table-seplag>
        </div>
      </div>
    </cadastro-rapido>
  </card-seplag>
</template>

<script>
import CardSeplag from "@/template/CardSeplag.vue";
import CadastroRapido from "@/template/CadRapidoSeplag.vue";
import TableSeplag from "@/template/TableSeplag.vue";
import Column from "primevue/column";
import Rotulo from "@/template/RotuloSeplag.vue";
import { baseApiUrl } from "@/config/global";

export default {
  name: "controlePerfilChefia",
  components: { CardSeplag, Rotulo, Column, CadastroRapido, TableSeplag },
  data: function () {
    return {
      exibirServidores: false,
      parametroPesquisa: "",
      totalRecords: 0,
      totalRecordsServidorUnidade: 0,

      orgaoBusca: [],
      unidadesDisponiveis: [],
      listaServidorUnidade: [],
      listaUnidadesFiltro: [],

      parametroPesquisaListaServidor: null,
      orgaoSelecionado: null,
      unidadeSelecionada: null,
      unidadeSelecionadoFiltro: null,
      isPerfil: "OPERADOR",
      isUnidadeChefia: false,
    };
  },
  methods: {
    async carregarDados() {
      this.isPerfil = this.$store.getters.getPerfilAcesso
        ? this.$store.getters.getPerfilAcesso
        : "OPERADOR";
      this.$http.get(`${baseApiUrl}/feriasview/orgaosperfil`).then((res) => {
        this.orgaoBusca = res.data.map(function (element) {
          return {
            ...element,
            labelDropDaw: element.codgSeap + " - " + element.siglUnidade,
          };
        });
      });
    },
    buscaUnidadesVinculado() {
      this.$http
        .get(
          `${baseApiUrl}/feriasview/unidades/${this.orgaoSelecionado.idenOrgao}`
        )
        .then((res) => {
          this.listaUnidadesFiltro = res.data.map(function (element) {
            return {
              ...element,
              labelDropDaw: element.codgSeap + " - " + element.siglUnidade,
            };
          });
        });
    },
    buscaUnidadeFiltro(size = 10, page = 0) {
      this.$http
        .post(
          `${baseApiUrl}/chefiaorgaounidade/buscaunidadechefia?size=${size}&page=${page}`,
          JSON.stringify({
            idenOrgao: this.orgaoSelecionado
              ? this.orgaoSelecionado.idenOrgao
              : null,
            codgSeap: this.unidadeSelecionadoFiltro
              ? this.unidadeSelecionadoFiltro.codgSeap
              : "",
          })
        )
        .then((res) => {
          this.unidadesDisponiveis = res.data.content;
          this.totalRecords = res.data.totalElements;
        });
    },

    abrirModalServidores(unidade) {
      this.listaServidorUnidade = [];
      this.exibirServidores = true;
      this.$http
        .post(
          `${baseApiUrl}/chefiaorgaounidade/servidores/${unidade.idenUnidade}?size=10&page=0`,
          JSON.stringify({
            parametroPesquisa: this.parametroPesquisaListaServidor,
          })
        )
        .then((res) => {
          this.unidadeSelecionada = unidade;
          this.listaServidorUnidade =
            res.data.content.length > 0
              ? res.data.content.map(function (element) {
                  if (unidade.chefes.length > 1) {
                    for (let i = 1; i < unidade.chefes.length; i++) {
                      if (element.idenPessoa == unidade.chefes[i].idenPessoa) {
                        return { ...element, checked: true, chefeSEAP: false };
                      }
                    }
                  }
                  if (
                    unidade.chefes.length > 0 &&
                    element.idenPessoa == unidade.chefes[0].idenPessoa &&
                    unidade.flagPermissaoAlterar == "N"
                  ) {
                    return { ...element, checked: true, chefeSEAP: true };
                  }
                  if (
                    unidade.chefes.length > 0 &&
                    element.idenPessoa == unidade.chefes[0].idenPessoa
                  ) {
                    return { ...element, checked: true, chefeSEAP: false };
                  } else {
                    return { ...element, checked: false, chefeSEAP: false };
                  }
                })
              : [];
          if (this.unidadeSelecionada.chefes.length > 0) {
            this.isUnidadeChefia = true;
          } else {
            this.isUnidadeChefia = false;
          }
          this.totalRecordsServidorUnidade = res.data.totalElements;
          this.exibirServidores = true;
        });
    },

    paginacaoListaServidores(size, page) {
      this.$http
        .post(
          `${baseApiUrl}/chefiaorgaounidade/servidores/${this.unidadeSelecionada.idenUnidade}?size=${size}&page=${page}`,
          JSON.stringify({
            parametroPesquisa: this.parametroPesquisaListaServidor,
          })
        )
        .then((res) => {
          let unidade = this.unidadeSelecionada;
          this.listaServidorUnidade =
            res.data.content.length > 0
              ? res.data.content.map(function (element) {
                  if (unidade.chefes.length > 1) {
                    for (let i = 1; i < unidade.chefes.length; i++) {
                      if (element.idenPessoa == unidade.chefes[i].idenPessoa) {
                        return { ...element, checked: true, chefeSEAP: false };
                      }
                    }
                  }
                  if (
                    unidade.chefes.length > 0 &&
                    element.idenPessoa == unidade.chefes[0].idenPessoa &&
                    unidade.flagPermissaoAlterar == "N"
                  ) {
                    return { ...element, checked: true, chefeSEAP: true };
                  }
                  if (
                    unidade.chefes.length > 0 &&
                    element.idenPessoa == unidade.chefes[0].idenPessoa
                  ) {
                    return { ...element, checked: true, chefeSEAP: false };
                  } else {
                    return { ...element, checked: false, chefeSEAP: false };
                  }
                })
              : [];
          this.totalRecordsServidorUnidade = res.data.totalElements;
        });

      // let postBody = {
      //     listaOrgaos: [this.unidadeSelecionada.idenOrgao],
      //     listaPerfilAcesso: null,
      //     textoPesquisa: this.parametroPesquisaListaServidor,
      //     usuarioLogado: this.$store.getters.getUser.contaAcesso.pessoa.nomePessoa
      // }
      // this.$http.post(`${baseApiUrl}/seguranca/contasacesso/usuario?size=${size}&page=${page}`, JSON.stringify(postBody)).then(res => {
      //     this.listaServidorUnidade = res.data.content
      //     this.listaServidorUnidade.map((element) => {
      //         if (unidade.chefes.length > 0 && element.pessoa.idenPessoa == unidade.chefes[0].idenPessoa) {
      //             return { ...element, checked: true }
      //         } else {
      //             return { ...element, checked: false }
      //         }

      //     })
      //     this.totalRecordsServidorUnidade = res.data.totalElements
      //     this.controle = true
      // })
    },

    fecharModalServidores() {
      this.exibirServidores = false;
    },

    atribuirChefiaUnidade(servidor) {
      if (this.perfilCentral == false && this.controle == true) {
        this.$toast.add({
          severity: "error",
          summary: "Não Possui Permissão para essa Ação",
          life: 3000,
        });
        return;
      }
      let tipo = servidor.checked ? "atribuir" : "remover";
      this.$http
        .post(
          `${baseApiUrl}/chefiaorgaounidade/atribuirPerfilChefia/${this.unidadeSelecionada.idenUnidade}/${servidor.idenPessoa}/${tipo}`
        )
        .then((res) => {
          if (res.data) {
            this.listaServidorUnidade = this.listaServidorUnidade.map(function (
              element
            ) {
              if (
                element.checked == true &&
                element.idenPessoa != servidor.idenPessoa
              ) {
                element.checked = false;
              }
              if (
                element.idenPessoa == servidor.idenPessoa &&
                servidor.checked == false
              ) {
                element.checked = false;
              }
              return element;
            });
            let listaCheifa = [];
            if (
              this.unidadeSelecionada.chefes.length > 0 &&
              this.unidadeSelecionada.flagPermissaoAlterar == "N"
            ) {
              listaCheifa.push(this.unidadeSelecionada.chefes[0]);
            }
            if (servidor.checked) {
              listaCheifa.push(servidor);
            }
            this.unidadeSelecionada.chefes = listaCheifa;
            //this.paginacaoListaServidores(10, 0);
          }
        });
    },
  },
  mounted() {
    this.carregarDados();
  },
};
</script>

<style>
.alinhamentoBuscaOrgaoVinculado {
  align-items: flex-end;
  justify-content: center;
}

.alinamentoTextoModalOrgaoVinculado {
  text-align: center;
}
</style>
